export default {
  ALL: 'all',
  LEGACY: 'legacy',
  LATITUDE: 'latitude',
  NOT_SET: 'not-set',
};
